/**
 * Live store hours under the Winkel header banner. Liquid renders a fallback,
 * but Shopify can serve a cached page, so the line is recomputed in the browser.
 * PROTOTYPE: hours are hard-coded here (0 = Sunday); they move to block settings later.
 */
const CLOSING = { 1: '18:00', 2: '18:00', 3: '18:00', 4: '18:00', 5: '18:00', 6: '17:00' };
const DAYS = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];

function minutes(time) {
  const [h, m] = time.split(':').map(Number);
  return h * 60 + m;
}

function storeLine(now) {
  const today = now.getDay();
  const close = CLOSING[today];
  if (close && now.getHours() * 60 + now.getMinutes() < minutes(close)) {
    return `Geopend tot ${close}`;
  }
  for (let i = 1; i <= 7; i++) {
    const day = (today + i) % 7;
    if (CLOSING[day]) return i === 1 ? 'Morgen weer open' : `Weer open op ${DAYS[day]}`;
  }
  return '';
}

export function initHeaderCtas() {
  const lines = document.querySelectorAll('[data-bx-store-hours]');
  if (!lines.length) return;
  const update = () => {
    const text = storeLine(new Date());
    if (text) lines.forEach((line) => (line.textContent = text));
  };
  update();
  window.setInterval(update, 60 * 1000);
}
